import api from '@/api/index';
// eslint-disable-next-line import/extensions
import SHA256 from 'crypto-js/sha256.js';
import { getCookieValue } from './utils';

const sha256 = (value) => SHA256(value).toString();

const setTtq = function (eventName, eventId, contents, currency, value) {
  try {
    if (process.client && window?.sgtmPixelConfig?.tiktok === false) {
      return;
    }
    const userInfor = localStorage.getItem('voo-userInfo')
      ? JSON.parse(localStorage.getItem('voo-userInfo'))
      : {};
    const d = new Date();
    d.setHours(d.getHours(), d.getMinutes() - d.getTimezoneOffset());
    return api.others.ttApi({
      event: eventName,
      event_id: `${eventId}` || '',
      event_time: Math.trunc(new Date().valueOf() / 1000),
      user: {
        ttclid: getCookieValue('ttclid') || null,
        ttp: getCookieValue('_ttp') || '',
        user_agent: navigator.userAgent,
        external_id: userInfor.id ? `${userInfor.id}` : null,
        phone: userInfor.telephone ? sha256(userInfor.telephone) : null,
        email: userInfor.email ? sha256(userInfor.email) : null,
      },
      properties: {
        contents: contents || null,
        currency: currency || null,
        value: value || null,
      },
    });
  } catch (error) {
    console.log(error);
  }
};

export default setTtq;
